import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "passPage page"
  }, [_c('m-head'), _c('div', {
    staticClass: "passPage-bg",
    style: {
      background: `url(${require(`@images/pass/pass-bg.jpg`)}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "passPage-main page-main"
  }, [_c('div', {
    staticClass: "passPage-head"
  }, [_c('div', {
    staticClass: "passPage-head__img",
    style: {
      background: `url(${require('@images/icon/icon-pass.png')}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "passPage-head__title"
  }, [_vm._v("AIRDROP PASS")])]), _c('div', {
    staticClass: "passPage-total"
  }, [_c('div', {
    staticClass: "passPage-total__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.airdrop_ticket, 2)))]), _c('div', {
    staticClass: "passPage-total-progress"
  }, _vm._l(5, function (_, index) {
    return _c('div', {
      staticClass: "passPage-total-progress-item",
      style: {
        background: `url(${require(`@images/pass/pass-progree-item${index <= 0 ? '-active' : ''}.png`)}) center/auto 100% no-repeat`
      }
    });
  }), 0)]), _vm._m(0), _c('div', {
    staticClass: "passPage-way"
  }, [_c('div', {
    staticClass: "passPage-way-bg",
    style: {
      background: `url(${require(`@images/pass/pass-way-bg.jpg`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "passPage-way-main"
  }, [_c('div', {
    staticClass: "passPage-way__title"
  }, [_vm._v("Ways to Earn Airdrop pass")]), _c('div', {
    staticClass: "passPage-way-list"
  }, _vm._l(_vm.wayList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "passPage-way-item",
      on: {
        "click": () => _vm.$router.push(item.path)
      }
    }, [_c('div', {
      staticClass: "passPage-way-item-main"
    }, [_c('span', {
      attrs: {
        "data-index": index + 1
      }
    }, [_vm._v(_vm._s(item.name))])])]);
  }), 0)])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "passPage-intro"
  }, [_c('div', {
    staticClass: "passPage-intro__label"
  }, [_vm._v("AirdropPass boosts your airdrop eligibility and unlocks exclusive Web3 perks.")]), _c('div', {
    staticClass: "passPage-intro__more"
  }, [_vm._v("More passes = bigger rewards.")])]);
}];
export { render, staticRenderFns };